<template>
    <div v-if="! loading">
        <div class="row">
            <div class="col text-right mb-2">
                <b-button class="mr-sm-1 mr-md-1" :href="$routes.route('team.create')"><i class="far fa-fw fa-plus"></i>
                    Create</b-button>
            </div>
        </div>
        <b-row class="mb-2">
            <b-col class="col-12">
                <b-card class="mb-0">
                    <b-card-title title-tag="h5" title="Teams"></b-card-title>
                    <b-card-body class="px-0">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th class="col-6">Name</th>
                                    <th class="col-4">Display</th>
                                    <th class="col-2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="team in teams" :key="team.id">
                                    <td class="col-6">{{ team.name }}</td>
                                    <td class="col-4 text-center" :style="'background-color:' + team.color + '!important;color:' + team.text_color + '!important;'"><strong>{{ team.name }}</strong></td>
                                    <td class="col-2"><b-button size="sm" :href="$routes.route('team.edit', {team: team.id})"><i class="fas fa-fw fa-edit"></i> Edit</b-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            teams: [],
            loading: false,
        }
    },
    methods: {
        getTeams() {
            axios.get(this.$routes.route('team.index'), {params: {getData: true}})
                .then(response => {
                    this.teams = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        init() {
            this.getTeams();
        }
    },
    mounted() {
        this.loading = true;
        this.init();
    }
}
</script>